import { Table, Button } from "react-bootstrap";
import CustomModal from "../../../components/customModal/CustomModal";
import { useEffect, useState } from "react";
import useMckesson from "../../../Hooks/useMckesson";
import Loading from "../../../components/LoadingPage/Loading";
import moment from "moment";
import { toast } from "react-toastify";

export const ApprovalItems = ({
  showApprovalModal,
  toggleApprovalModal,
  orderId,
  orderNo,
}: {
  showApprovalModal: boolean;
  toggleApprovalModal: () => void;
  orderId: string;
  orderNo: string;
}) => {
  const [approvalItems, setApprovalItems] = useState<any[]>([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [notes, setNotes] = useState("");
  const {
    getMckessonWorkflowItemsAPI,
    getMckessonWorkflowItemsLoading,
    putMckessonWorkflowItemAPI,
    putMckessonWorkflowItemLoading,
  } = useMckesson();

  const fetchApprovalItems = () => {
    getMckessonWorkflowItemsAPI({ key: orderId }).then((res: any) => {
      if (res) {
        setApprovalItems(res);
      }
    });
  };

  useEffect(() => {
    if (showApprovalModal && orderId) {
      fetchApprovalItems();
    }
    if (!showApprovalModal) {
      setSelectedRowIndex(null);
      setNotes("");
    }
  }, [showApprovalModal, orderId]);

  const handleApproveReject = async (isApproved: boolean) => {
    if (selectedRowIndex === null) return;
    try {
      const selectedItem = approvalItems[selectedRowIndex];
      const updatedItem = {
        ...selectedItem,
        isApproved,
        notes,
      };
      await putMckessonWorkflowItemAPI([updatedItem]);
      toast.success(
        isApproved
          ? "Success! Order has been Approved."
          : "Success! Order has been Rejected."
      );
      toggleApprovalModal();
    } catch (err) {
      // error handled in hook
    }
  };

  return (
    <>
      {(getMckessonWorkflowItemsLoading || putMckessonWorkflowItemLoading) && (
        <Loading />
      )}
      {showApprovalModal && (
        <CustomModal
          id="approvalItemsModal"
          title="Approval Items"
          content={
            <div className="modal--content--wrapper">
              <div className="modal--inputbox">
                <Table>
                  <thead>
                    <tr>
                      <th>PO #</th>
                      <th>Approver</th>
                      <th>Email</th>
                      <th>Sequence</th>
                      <th>Approved?</th>
                      <th>Timestamp</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvalItems?.length > 0 ? (
                      approvalItems.map((item: any, index: number) => (
                        <tr
                          key={index}
                          className={selectedRowIndex === index ? "selected-row" : ""}
                          onClick={() => {
                            setSelectedRowIndex(index);
                            setNotes(item.notes ?? "");
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{orderNo || "-"}</td>
                          <td>
                            {item.user?.userName ||
                              (item.user?.fName || item.user?.lName
                                ? `${item.user?.fName ?? ""} ${item.user?.lName ?? ""}`.trim()
                                : "-")}
                          </td>
                          <td>{item.user?.email ?? "-"}</td>
                          <td>{item.approvalWorkflow?.approvalMode?.index ?? "-"}</td>
                          <td>
                            {item.isApproved === true
                              ? "Yes"
                              : item.isApproved === false
                                ? "No"
                                : "-"}
                          </td>
                          <td>
                            {item.timestamp
                              ? moment(item.timestamp).format(
                                "MM/DD/YYYY HH:mm:ss"
                              )
                              : ""}
                          </td>
                          <td>{item.notes ?? ""}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center" }}>
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <p className="record-count-text">
                  {approvalItems?.length ?? 0} record(s)
                </p>
                {selectedRowIndex !== null && (
                  <div style={{ padding: "12px 16px" }}>
                    <label htmlFor="approvalNotes" className="form-label fw-bold">
                      Notes:
                    </label>
                    <textarea
                      id="approvalNotes"
                      className="form-control"
                      rows={3}
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                    />
                  </div>
                )}
              </div>
            </div>
          }
          footer={
            <div className="modal--action--btn--wrapper text-end">
              <Button
                type="button"
                variant="primary"
                disabled={selectedRowIndex === null}
                onClick={() => handleApproveReject(true)}
              >
                Approve
              </Button>
              <Button
                type="button"
                variant="danger"
                disabled={selectedRowIndex === null}
                onClick={() => handleApproveReject(false)}
              >
                Reject
              </Button>
              <Button
                type="button"
                variant="secondary"
                onClick={toggleApprovalModal}
              >
                Cancel
              </Button>
            </div>
          }
          onClose={toggleApprovalModal}
        />
      )}
    </>
  );
};
